/* Daddy Enterprises — scroll reveal.
   Fades sections up as they enter the viewport.

   Content is visible by default in CSS. The hiding rules are gated behind
   html[data-de-reveal="on"], which a small inline snippet in <head> sets
   before first paint; this file runs deferred and only observes. If it
   cannot, it removes the attribute again, so a script failure can never
   leave the page blank. */
(function () {
  var SELECTOR = '.de-reveal';

  // The inline snippet in <head> has already armed the CSS before first
  // paint. If this environment cannot run the observer, disarm it again so
  // nothing is left stranded at opacity 0.
  if (
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    document.documentElement.removeAttribute('data-de-reveal');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  );

  function observe(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
    });
  } else {
    observe();
  }

  // The theme editor swaps section markup in without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  // Failsafe: if anything goes wrong with the observer, never leave copy
  // stranded at opacity 0. Disarming the attribute restores every element
  // at once, animation or not.
  window.setTimeout(function () {
    var hidden = document.querySelectorAll(SELECTOR + ':not(.is-visible)');
    if (!hidden.length) return;
    var vh = window.innerHeight;
    var stranded = [].filter.call(hidden, function (el) {
      // Only worry about elements that should already have been seen.
      return el.getBoundingClientRect().top < vh;
    });
    if (stranded.length) {
      document.documentElement.removeAttribute('data-de-reveal');
    }
  }, 4000);
})();
